document.addEventListener('DOMContentLoaded', () => {
  const gallery = $('.profile-gallery');
  const carousel = gallery.find('.carousel');
  const items = carousel.find('[class$="inner"]').children();

  if (items.length > 1) {
    carousel.carousel();
    gallery.find('.left.carousel-control').click(() => carousel.carousel('prev'));
    gallery.find('.right.carousel-control').click(() => carousel.carousel('next'));
  } else if (items.length === 1) {
    items.eq(0).addClass('active');
    $('.media-nav').css('visibility', 'hidden');
  }

  $(".prettyPhoto").prettyPhoto({
    theme: 'custom',
    overlay_gallery: false
  });

});

